<template>
  <div class="directory-search">
    <form
      @submit.prevent="doSearch($event)"
    >
      <div class="input-group">
        <input
          type="text"
          name="q"
          placeholder="Search by Name"
          :value="searchTerm"
          aria-label="Search by Name"
        >
        <button type="submit" aria-label="Search" v-html="assets.search"></button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'DirectorySearch',

  props: {
    searchTerm: {
      type: String,
      default: null
    },
    assets: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    doSearch (e) {
      const search = e.target.q.value

      if (search) {
        this.$parent.setSearch(search)
      } else {
        this.$parent.setSearch(null)
      }
    }
  }
}
</script>
